import { RootState } from "../index";

export const selectCartPopUpState = (state: RootState) =>
  state.cartPopUp.isOpen;
